module.exports = __webpack_public_path__ + "static/media/reset-password.e1b321d7.png";